import React from 'react'

const CS = () => {
  return (
    <div>CS</div>
  )
}

export default CS